import React from 'react'
import { BaseButton, Box, Button, Flex, Text, Stack } from '../../../../vanilla'
import { useCustomerStore, useGlobalStore, usePreBookStore } from '../../../../store/hooks/useStore'
import { startOfDay, subDays, differenceInDays, differenceInCalendarDays, format } from 'date-fns'
import { slotBaseId, scrollToBooking } from '../../../../utils/booking-utils'
import useNavigation from '../../../../hooks/use-navigation'

 export const PreBookActiveReservation = () => {
    const navigate = useNavigation()
    function displayAddress() {
        const {address1, address2, stateCode, city, postalCode} = preBookedAddress
        return [address1, address2, stateCode, city, postalCode].filter(Boolean).join(', ')
    }

    const {customSitePreferences} = useGlobalStore()
    const seasonalName = customSitePreferences['preBookSeasonalName'] || ''
    const {preBookedAddress} = useCustomerStore()
    const {prebookedOrder} = usePreBookStore()
    const deliveryWindowLength = customSitePreferences['deliveryWindowLength'] as number ?? 7
    const availableFrom = subDays(startOfDay(new Date(prebookedOrder?.c_windowStartTime)), deliveryWindowLength - 1) 
    const availableInDays = differenceInCalendarDays(availableFrom, new Date())
    const availableToUse = availableInDays <= 0
    const expiresToday = differenceInDays(new Date(prebookedOrder?.c_slotExpiryTime), new Date()) === 0
    const preBookSlotId = slotBaseId(prebookedOrder?.c_deliverySlotId)

    // Format prebook callout heading text
    const headingText = (availableToUse ? 
      `Your pre-booked ${seasonalName} delivery slot ${expiresToday ? 'expires today!' : 'is ready to use!'}`
      : `Your ${seasonalName} delivery is prebooked`
    ).replace('  ',' ')

    // Format prebook callout body text
    const windowFrom = format(new Date(prebookedOrder?.c_windowStartTime), 'EEEE do MMMM HH:mm')
    const windowTo = format(new Date(prebookedOrder?.c_windowEndTime),'HH:mm')
    const bookingText = `${displayAddress()} on ${windowFrom} - ${windowTo}`
    const formattedAvailableInDaysText = availableInDays > 1 ? `${availableInDays} Days` : '1 Day'

    // On-Click handler for the Activate button
    function handleActivateClick() {
        if(location.pathname === '/book-delivery') {
            // If we're already on the BAS page, scroll to the slot
            const clickTab = format(new Date(prebookedOrder?.c_windowStartTime), 'doMMMM')
            scrollToBooking(preBookSlotId, clickTab)
        } else {
            // If we're on another page, navigate to the page, and it will handle the scroll
            navigate('/book-delivery?prebook=true') 
        }
    }

    return (
        <> 
        <Box
            display="flex"
            flexDirection="column"
            backgroundColor={ 
                availableToUse ? 
                    expiresToday ? 'alertWarningImportantBackground' 
                    : 'alertWarningBackground' 
                : 'white' 
            }
            paddingX={["16px", "28px"]}
            paddingY="16px"
            border={availableToUse ? "1px" : "0px"}
            borderColor={ 
                availableToUse ? 
                    expiresToday ? 'alertWarningImportantBorder' 
                    : 'alertWarningBorder' 
                : 'white' 
            }
            borderRadius="slight"
        >
            <Text 
                variant="heading1" 
                paddingY="12px"
                borderBottom="1px"
                borderColor="gray500">
                {headingText}
            </Text>
            <Flex
                alignItems={['flex-start', 'center']}
                paddingLeft={['0px']}
                paddingY={["10px"]}
            >
                <Stack width="full">
                    <Text variant="text1" lineHeight="none">Delivery Prebooked for:</Text>
                    <Text variant="text1Light" lineHeight="none">{bookingText}</Text>
                </Stack>
                {availableToUse ? (
                    <Button
                        size="sm"
                        variant="primary"
                        maxHeight="40px"
                        width="100px"
                        style={{width: '100px'}}
                        onClick={handleActivateClick}
                    >
                        Activate
                    </Button>
                ) : (
                    <BaseButton
                        paddingY="8px"
                        paddingX="20px"
                        width="100px"
                        height="56px"
                        padding="none"
                        backgroundColor="ctaWarning"
                        color="gray1000"
                        borderRadius="base"
                        variant="unstyled">
                        <Stack width="full" alignItems={['center']}>
                            <Text variant="text3Bold" 
                                  lineHeight="none">
                                Available in
                            </Text>
                            <Text variant="text7" lineHeight="none">
                                {formattedAvailableInDaysText}
                            </Text>
                        </Stack>
                    </BaseButton>
                )}
            </Flex>
        </Box>
        </>
    )
}